import React from 'react';
import styled from 'styled-components';
import parse from 'html-react-parser';
import Text from '../shared/Text';
import { palette } from '../../constants/styles';
import Title from '../shared/Title';

const Card = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  background-color: ${palette.sweetGray};
  border-radius: 15px;
  width: 95%;
  padding: 5px 15px;
  margin-top: 50px;
  z-index: 300;
  background-color: white;
  border: 2px dashed ${palette.secondaryColor};
`;

const SuggestionCard = ({ text }) => (
  <Card>
    <Title level={5} align="left" medium>
      { parse(`${text}`) }
    </Title>
  </Card>
);

export default SuggestionCard;
